export default "__VITE_ASSET__ca1c1445__"